import {
    faColumns,
    faFileExcel,
    faPlus,
    faFilter,
    faChevronUp,
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import React, { useState } from "react";
  import { Link } from "react-router-dom";
  import { toast } from "react-toastify";
  import { useAppContext, usePersistedState } from "../../../AppContext";
  import func, { removePropertiesRecursive, validateInvoice } from "../../../services/functions";
  import mainAxios from "../../../services/mainAxios";
  import Loader from "../../Layout/Loader";
  import Select from "react-select";
  import UploadInvoice from "../../Invoice/UploadInvoice";
  import { useTranslation, withTranslation } from "react-i18next";
  import Swal from "sweetalert2";
  import DateRange from "../../global/DateRange";
  import AlertCertificate from "../../global/AlertCertificate";
  import PrimeTable from "../../PrimeTable/PrimeTable";
  import ExportCsvPrime from "../../global/ExportCsvPrime";
  import { useHistory } from 'react-router-dom'
  import { globalFilterStatisticCard } from "../../global/StatisticsCards";
  import { defaultTableRows, validateTransportInvoice } from "../../../services/data";
import generateTransportColumns from "./generateTransportInvColumns";
import { duplicateInvoice, getTransportInvoice } from "./Utils";
import selectStyle from "../../../design/selectStyle";


  const moment = require("moment");
  
  const TransportInvoices = () => {
    const { t } = useTranslation("translations");
  
    const {
      user: [user],
      selectedCompany: [selectedCompany],
      company: [fullCompany],
      dates: [dates, setDates],
    } = useAppContext();
  
    const company = user.companiesRights.find(
      (company) => company.id === parseInt(selectedCompany)
    );
  
    const [loadingDuplicate, setLoadingDuplicate] = useState(false);
    const [transportInvoices, setTransportInvoices] = useState(null);
    const [invoicesForCSV, setInvoicesForCSV] = useState([]);
    const [pageState, setPageState] = React.useState({
      loading: true,
      saving: false
  })
    const [persistedData, setPersistedData] = usePersistedState(
      null,
      "sessionData"
    );
  
    const [refresh, setRefresh] = useState(false)
    const [filtersCollapsed, setFiltersCollapsed] = usePersistedState(false, "transportInvoicesFiltersCollapsed")

    const [persistedRowPerPage, setPersistedRowPerPage,] = usePersistedState(
      10,
      "rowsPerPage"
  );
  
    const defaultSortCriteria={
      field: "issueDate",
      direction: "DESC"
    }
  
    const [tableRows, setTableRows] = useState({
      ...defaultTableRows,
      rowsPerPage: persistedRowPerPage,
      sortCriteria: defaultSortCriteria
    });
  
    const businessUnitCodes = React.useMemo(() => {
      return [
        {
          label: t("invoice.businessUnitCode"),
          value: null,
        },
      ].concat(
        company.branches.map((branch) => {
          return {
            label: branch.businUnitCode + " | " + branch.sellerName,
            value: branch.businUnitCode,
          };
        })
      );
    }, [selectedCompany]);
  
    const filterParams = {
      businessUnitCode: businessUnitCodes?.some(
        (branch) => branch?.value === persistedData?.businessUnitCode
      )
        ? persistedData?.businessUnitCode
        : null,
      internalId: null,
      operatorCode: null,
      tiic: null,
      ftiic: null,
      startAddress: null,
      destinationAddress: null,
      status: null,
      type: null,
      transaction: [],
      idType: null,
      statusObj: [],
      transporterId: null,
      tiOrderNum: null,
      valueOfGoods: null,
      issueDate: null,
      vehiclePlate:null,
      transporterIdType:null,
      vehicleOwnership:null,
      startingPoint:null,
      pointOfArrival:null,
      tiStartDate:null,
      tiEndDate:null
    };
  
    const defaultFilters = {
      fromDate: dates.fromDate,
      toDate: dates.toDate,
      params: {
        ...filterParams,
      },
    };
  
    const [errors, setErrors] = React.useState([]);
    const [filters, setFilters] = React.useState(defaultFilters);

    const filterCount = React.useMemo(() => {
      let count = 0;
      const params = filters?.params;
      if (defaultFilters && params) {
        Object.keys(params).forEach(key => {
          const value = params[key];
          const isDefault = JSON.stringify(value) === JSON.stringify(defaultFilters?.params?.[key]);
          if (!isDefault && value != null) {
            Array.isArray(value) ? count += value.length : count++;
          }
        });
      }
      return count;
    }, [defaultFilters, filters]);

    const [showDeleted, setShowDeleted] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [statistics, setStatistics] = useState(null);
    const [pdfToDisplay, setPdfToDisplay] = React.useState(null);
    const [loadingPdf, setLoadingPdf] = React.useState(false);
    const pdfContainer = React.useRef();
    const history = useHistory()
  
    const getFilteredResults = ({ data, pageSize = (persistedRowPerPage?? defaultTableRows.rowsPerPage),
      page = defaultTableRows.currentPage, sortCriteria = [ defaultSortCriteria ],exportCsv }={}) => {
      let tiFilters = data ? data : filters;
      let params = tiFilters?.params;
      if(!exportCsv) setLoading(true);
      // const { rowsPerPage: pageSize , currentPage: pageNumber }=tableRows
      return mainAxios
        .post("apiEndpoint/search", {
          object: "GetCustomTiV",
          ...tiFilters,
          pagination:exportCsv?null: {
            pageSize,
            pageNumber:page,
          },
          params: {
            ...(params?.businessUnitCode && {
              businessUnitCode: "<L>" + params.businessUnitCode + "<L>",
            }),
            ...(params?.internalId && { internalId: "<L>" +  params?.internalId + "<L>" }),
            ...(params?.transporterName && { transporterName: "<L>" +  params?.transporterName + "<L>" }),
            ...(params?.receiverName && { receiverName: "<L>" +  params?.receiverName + "<L>" }),
            ...(params?.receiverNipt && { receiverNipt: "<L>" +  params?.receiverNipt + "<L>" }),
            ...(params?.operatorCode && { operatorCode: "<L>" + params?.operatorCode + "<L>" }),
            ...(params?.recordUser && { recordUser: "<L>" + params?.recordUser + "<L>" }),
            ...(params?.startAddress && { startAddress: "<L>" + params?.startAddress + "<L>",
            }),
            ...(params?.destinationAddress && { destinationAddress: "<L>" + params?.destinationAddress + "<L>" ,
            }),
            ...(params?.tiic && { tiic: "<L>" + params?.tiic + "<L>" }),
            ...(params?.idType && { idType: "<L>" + params?.idType + "<L>" }),
            ...(params?.ftiic && { ftiic: "<L>" + params?.ftiic + "<L>" }),
            ...(params?.status && { status: "<L>" + params?.status + "<L>" }),
            ...(params?.type && { type: params.type }),
            ...(params?.transaction?.length > 0 && {
              transaction: params.transaction.join(","),
            }),
            ...(params?.transporterId && { transporterId: params.transporterId }),
            ...(params?.statusObj?.length > 0 && {
              statusObj: params.statusObj.join(","),
            }),
            ...(params?.goodsFammable && { goodsFammable: params.goodsFammable }),
            ...(params?.tiOrderNum && { tiOrderNum: "<L>" + params.tiOrderNum + "<L>" }),
            ...(params?.valueOfGoods && { valueOfGoods: params.valueOfGoods }),
            ...(params?.issueDate && { issueDate: params.issueDate }),
            ...(params?.vehiclePlate && { vehiclePlate: "<L>" + params.vehiclePlate + "<L>" }),
            ...(params?.transporterIdType && { transporterIdType: params.transporterIdType }),
            ...(params?.vehicleOwnership && { vehicleOwnership: params.vehicleOwnership }),
            ...(params?.startingPoint && { startingPoint: params.startingPoint }),
            ...(params?.pointOfArrival && { pointOfArrival: params.pointOfArrival }),
            ...(params?.tiStartDate && { tiStartDate: params.tiStartDate }),
            ...(params?.tiEndDate && { tiEndDate: params.tiEndDate }),
          },
          sortCriteria
        })
        .then((res) => {
          if(!exportCsv) setLoading(false);
          if (res?.data?.status === true) {
            if(exportCsv){
              setInvoicesForCSV(res.data.content);
            }else{
              setTableRows((tableRows)=>({
                ...tableRows,
                  totalRows: res?.data?.totalSize,
              }));
            setTransportInvoices(res.data.content);
            }
            return true
          } else {
            toast.warning(t(["toast.warningInvoice"]), {
              containerId: "all_toast",
            });
            setTransportInvoices([]);
          }
          return false
        })
        .catch((err) => {
          if(!exportCsv) setLoading(false);
          return false;
        });
    };
  
    React.useEffect(() => {
      getFilteredResults();
    }, [selectedCompany, refresh]);
  

  
    const handleParamsChange = (e, label, val) => {
      const key = e ? e.target.name : label;
      const value = e ? e.target.value : val;
  
      setFilters((filters) => ({
        ...filters,
        params: {
          ...filters.params,
          [key]: value,
        },
      }));
    };
    const deleteTransportInv = (e, ti) => {
      e.preventDefault();
      setDeleting(true);
      mainAxios
        .post("apiEndpoint/saveOrUpdate", {
          object: "DeleteTI",
          content: {
            ...ti,
            id: ti?.id,
          },
          nuis: company.nuis,
        })
        .then((res) => {
          if (res?.data?.status === true) {
            setRefresh((refresh) => !refresh)
            toast.success("Draft TI was successfully deleted!", {
              containerId: "all_toast",
            });
          }
          setDeleting(false);
        })
        .catch(() => {
          toast.error("An error occurred! Please try again later.");
          setDeleting(false);
        });
    };
  
    const showTransportPdf = (tiic) => {
      setLoadingPdf(true);
      mainAxios
        .post("apiEndpoint/search", {
          object: "GetTiPDF",
          params: {
            tiic,
          },
        })
        .then((res) => {
          const blob = func.blobToFile(
            func.b64toBlob(res.data.content[0], "application/pdf"),
            "Transport Invoice"
          );
          setPdfToDisplay(URL.createObjectURL(blob));
          setTimeout(() => {
            pdfContainer.current.classList.toggle("open");
            setLoadingPdf(false);
          }, 0);
        });
    };
  
    React.useEffect(() => {
      if (!(filters?.fromDate && filters?.toDate)) {
        return;
      }
  

      mainAxios
        .post("endpoint/v2/reports/myti/company/aggregate", {
          object: "GetMyTiCashDepositStatisticsAnalytics",
          fromDate: moment(filters?.fromDate).format("YYYY-MM-DD"),
          toDate: moment(filters?.toDate).format("YYYY-MM-DD"),
          ...(filters?.params?.businessUnitCode
            ? { params: { businessUnitCode: filters?.params?.businessUnitCode } }
            : {}),
        })
        .then((res) => {
          if (res?.data?.status) {
            let getStatistics = calculateStatistics(res.data.content);
            setStatistics(getStatistics);
          }
        });
    }, [
      filters?.fromDate,
      filters?.toDate,
      filters?.params?.businessUnitCode,
      selectedCompany,
      refresh
    ]);
  
    const calculateStatistics = (data) => {
      if (data?.length > 0) {
        const {
          id,
          tcrCode,
          businessUnitCode,
          actionFrom,
          company,
          recordDate,
          ...rest
        } = data[0];
        let stats = {};
        Object.keys(rest).forEach((key) => {
          stats[key] = data.reduce((sum, tcrStat) => sum + tcrStat[key], 0);
        });
        return stats;
      }
      return [];
    };
  
  
    const statusOptions = [
      {
        key: "statusObj",
        count: statistics?.approvedTiNo,
        multiSelect: true,
        label: t("status.approved"),
        value: "9",
      },
      {
        key: "statusObj",
        count: statistics?.errorTiNo,
        multiSelect: true,
        label: t("home.error"),
        value: "35",
      },
      {
        key: "statusObj",
        count: statistics?.retryTiNo,
        multiSelect: true,
        label: t("status.retry"),
        value: "36",
      },
      {
        key: "statusObj",
        count: statistics?.deletedTiNo,
        multiSelect: true,
        label: t("status.deleted"),
        value: "10",
      },
      {
        key: "statusObj",
        count: statistics?.draftTiNo,
        multiSelect: true,
        label: t("status.draft"),
        value: "7",
      },
    ];
    const transactionOptions = [
      {
        key: "transaction",
        count: statistics?.processingTransactionNo,
        multiSelect: true,
        label: "Processing",
        value: "PROCESSING",  
      },
      {
        key: "transaction",
        count: statistics?.repairTransactionNo,
        multiSelect: true,
        label: t("status.repair"),
        value: "REPAIR",
      },
      {
        key: "transaction",
        count: statistics?.examinationTransactionNo,
        multiSelect: true,
        label: t("status.examination"),
        value: "EXAMINATION",
      },
    ];
  
  
    const transporterTypes = [
      {
        key: "transporterIdType",
        count: statistics?.companyTransporterNo,
        value: "NUIS",
        label: t("customers.company"),
      },
      {
        key: "transporterIdType",
        count: statistics?.idTransporterNo,
        value: "ID",
        label: t("status.individ"),
      },
    ];
  
    const userCompanyOperator =
      user?.userCompanyOperator?.map((userOpCode) => ({
        label: userOpCode.operator,
        value: userOpCode.operator,
      })) ?? [];
  
    const operatorCodes = [
      {
        label: "Select...",
        value: "",
      },
    ]
      .concat(
        [
          ...new Set(
            company.branches
              .reduce((tcrTypes, next) => tcrTypes.concat(next.tcrTypes), [])
              .map((tcrType) => tcrType.operatorCode)
          ),
        ].map((operatorCode) => ({
          label: operatorCode,
          value: operatorCode,
        }))
      )
      .concat(userCompanyOperator);
  
  
      const data =
      transportInvoices &&
      (showDeleted
        ? transportInvoices
        : transportInvoices.filter(
          (transportInvoice) => filters.params.statusObj.includes("10") && !loading ? true : transportInvoice.status.status !== "DELETED"
        ));
  
        const getDataFromTIRequest = ({transportInvoice}) => {
           return mainAxios.post("apiEndpoint/search", {
                object: "GetCustomTI",
                params: {
                    id: String(transportInvoice.id)
                }
            }).then(res => {
                if (res?.data?.status) {
                    return res.data.content[0]
                }
                return null
            }).catch((error)=>{
              return null
            })
        }


    const handleDublicateInvoice = async ({transportInv}) => {
          setLoadingDuplicate(true)
        const newState = await getTransportInvoice({id:transportInv.id?.toString()})
          if(!newState) {
                setLoadingDuplicate(false)
              return
          }
          const validateInvoiceFields = validateTransportInvoice({ setErrors, toast, state:newState,t });
          if (validateInvoiceFields) return;
          await duplicateInvoice({ state:newState,company,t,user,onSuccess:(res)=>{
              history.push(`/edit-transport-invoice/${res.data.content[0].id}`);
          }});
          setPageState((setPageState) => ({
              ...setPageState,
              saving: false,
          }));
          setLoadingDuplicate(false);
    };
      
  
  
    let columns = generateTransportColumns({
      showTransportPdf,
      loadingPdf,
      deleteTransportInv,
      deleting,
      operatorCodes,
      transportInvoices,
      t,
      handleDublicateInvoice,
      loadingDuplicate
    });
  
    const filterStatisticCard=(typeOptions,props)=>globalFilterStatisticCard(typeOptions,{...props,handleParamsChange,getFilteredResults,user,filters})
  
  
    const [selectedColumns, setSelectedColumns] = usePersistedState(
      columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})})),
      "wtnColumns2"
    );

    // Export icon for headerIcons
    const exportIcon = (
      <ExportCsvPrime
        selectedColumns={selectedColumns}
        iconOnly
        tooltip="Export CSV"
        data={invoicesForCSV}
        columns={columns}
        onClick={() => getFilteredResults({ exportCsv: true })}
        excludedColumns={["actions"]}
      />
    );

    return transportInvoices ? (
      <>
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
          <div className="left-header d-flex align-items-center">
            <h3 className="mb-0 p-2">{t("navbar.transportInv")}</h3>
            <Link to="/create-transport-invoice" className="btn btn-sm btn-primary ml-2">
              <FontAwesomeIcon icon={faPlus} className="mr-2" />
              {t("navbar.create")}
            </Link>
            <AlertCertificate />
          </div>
          <div className="d-flex align-items-center ml-auto">
            <div className="mr-2">
              <DateRange
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                onChange={(dates) => {
                  let fromDate = dates[0];
                  let toDate = dates[1];
                  if (fromDate && toDate) {
                    getFilteredResults({
                      data: {
                        fromDate,
                        toDate,
                        params: { ...filters.params },
                      }
                    });
                  }
                  setFilters((filters) => ({
                    ...filters,
                    fromDate,
                    toDate,
                  }));
                  setDates({ fromDate, toDate })
                }}
              />
            </div>
            <div className="d-flex align-items-center" style={{minWidth: "140px"}}>
              <label className="align-items-center mr-2 mb-0">BU</label>
              <Select
                styles={selectStyle}
                className="w-100"
                options={businessUnitCodes}
                value={
                  filters.params.businessUnitCode
                    ? businessUnitCodes.find(
                        (businessUnitCode) =>
                          businessUnitCode.value === filters.params.businessUnitCode
                      )
                    : {
                        label: t("invoice.businessUnitCode"),
                        value: "",
                      }
                }
                isSearchable={true}
                onChange={(businessUnitCode) => {
                  handleParamsChange(
                    null,
                    "businessUnitCode",
                    businessUnitCode.value
                  );
                  setPersistedData({
                    ...persistedData,
                    businessUnitCode: businessUnitCode.value,
                  });
                  getFilteredResults({data:{
                    ...filters,
                    params: {
                      ...filters.params,
                      businessUnitCode: businessUnitCode.value,
                    },
                  }});
                }}
                name="businessUnitCode"
              />
            </div>
          </div>
        </div>
        <div className="filter-cards-container d-none d-md-block">
          <div className="filter-cards-header">
            <button
              className={`filter-cards-toggle ${filtersCollapsed ? 'filter-cards-toggle--collapsed' : ''}`}
              onClick={() => setFiltersCollapsed(!filtersCollapsed)}
            >
              <FontAwesomeIcon icon={faFilter} />
              {filtersCollapsed ? (t("common.showFilters", "Show Filters")) : (t("common.hideFilters", "Hide Filters"))}
              {filterCount > 0 && <span className="badge badge-primary ml-1">{filterCount}</span>}
              <FontAwesomeIcon icon={faChevronUp} />
            </button>
          </div>
          <div className={`filter-cards-row ${filtersCollapsed ? 'filter-cards-row--collapsed' : ''}`}>
            <div className="filter-card-col">
              {filterStatisticCard(statusOptions, { title: t("home.status"), cardClasses: "stats-cols-2" })}
            </div>
            <div className="filter-card-col">
              {filterStatisticCard(transactionOptions, { title: t("invoice.transaction"), cardClasses: "stats-cols-2" })}
            </div>
            <div className="filter-card-col">
              {filterStatisticCard(transporterTypes, { title: t("invoice.transporter"), cardClasses: "stats-cols-1" })}
            </div>
          </div>
        </div>

        <div>
            <PrimeTable
              showFilters={true}
              filters={[filters, setFilters]}
              tableRows={[tableRows, setTableRows]}
              persistedRowPerPage={[persistedRowPerPage, setPersistedRowPerPage]}
              defaultFilters={defaultFilters}
              value={data}
              reorderableColumns={true}
              columns={columns}
              dataKey="ublId"
              onRemoteDataChange={(remoteData) => {
                const updatedFilters = remoteData.filters ?? filters
                   const updatedTableData = remoteData.tableRows ?? tableRows
                   let { currentPage, rowsPerPage,sortCriteria } = updatedTableData
                   sortCriteria=sortCriteria?[sortCriteria]:[]
                   getFilteredResults({ data: updatedFilters, pageSize: rowsPerPage, page: currentPage,sortCriteria })
              }}
              gridKey="wtnColumns2"
              selectedColumns={[selectedColumns, setSelectedColumns]}
              headerIcons={exportIcon}
              onClearFilter={() => {
                getFilteredResults({ data: { ...filters, params: { ...defaultFilters.params } } });
              }}
              columnDeps={[fullCompany,t]}
              likeValues={false}
              loading={loading}
              defaultSortCriteria={defaultSortCriteria}
              mobileFilterContent={
                <div className="filter-cards-row">
                  <div className="filter-card-col">
                    {filterStatisticCard(statusOptions, { title: t("home.status"), cardClasses: "stats-cols-2" })}
                  </div>
                  <div className="filter-card-col">
                    {filterStatisticCard(transactionOptions, { title: t("invoice.transaction"), cardClasses: "stats-cols-2" })}
                  </div>
                  <div className="filter-card-col">
                    {filterStatisticCard(transporterTypes, { title: t("invoice.transporter"), cardClasses: "stats-cols-1" })}
                  </div>
                </div>
              }
            />
        </div>

        <div className="pdf-container" ref={pdfContainer}>
          {pdfToDisplay && (
            <div className="pdf-viewer">
              <div
                className="pdf-overlay"
                onClick={() => {
                  setTimeout(() => {
                    setPdfToDisplay(null);
                  }, 150);
                  pdfContainer.current.classList.toggle("open");
                }}
              />
              <div className="pdf-content">
                <embed src={pdfToDisplay} />
              </div>
            </div>
          )}
        </div>
      </>
    ) : (
      <Loader />
    );
  };
  
  export default TransportInvoices;
  